<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isMemberBlacklistDetailV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="height: 220px; width:50%">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage['MEM']['ABL']}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="close3">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>

                                <div class='subHeaderHR'></div>

                                <CRow>
                                    <CCol col="12">
                                        <label class="col-form-label-sm">{{this.getLanguage["MEM"]["RR"]}}* :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_rejectreason"
                                                    :placeholder="getLanguage['MEM']['RR']"
                                                    v-model="obj_Reject.reason"
                                                    :limit="1"
                                                    :limitText="count => `+${count}`" />
                                    </CCol>
                                </CRow>
                                <CRow v-if="obj_Reject.reason==999">
                                    <CCol col="12">
                                        <CInput class="margint10" :placeholder="getLanguage['MTA']['RR']" size="sm" :value="obj_Reject.reason2" @change="v => obj_Reject.reason2 = v" :disabled="obj_Reject.reason!=999" maxlength="300"></CInput>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="12">
                                        <span class="ErrMsg">{{ ValidationBlackListErrMsg('reason2') }}</span>
                                    </CCol>
                                </CRow>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveBlacklist()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isMemberFreezeDetailV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="height: 220px; width:50%">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage['MEM']['AF']}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="close4">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>

                                <div class='subHeaderHR'></div>

                                <CRow>
                                    <CCol col="12">
                                        <label class="col-form-label-sm">{{this.getLanguage["MEM"]["FRR"]}}* :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_rejectreasonF"
                                                    :placeholder="getLanguage['MEM']['RR']"
                                                    v-model="obj_RejectF.reason"
                                                    :limit="1"
                                                    :limitText="count => `+${count}`" />
                                    </CCol>
                                </CRow>
                                <CRow v-if="obj_RejectF.reason==999">
                                    <CCol col="12">
                                        <CInput class="margint10" :placeholder="getLanguage['MTA']['FRR']" size="sm" :value="obj_RejectF.reason2" @change="v => obj_RejectF.reason2 = v" :disabled="obj_RejectF.reason!=999" maxlength="300"></CInput>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="12">
                                        <span class="ErrMsg">{{ ValidationFreezeErrMsg('reason2') }}</span>
                                    </CCol>
                                </CRow>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveFreeze()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["MEM"]["CMDI"]}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["U"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :load-options="loadMemberOptions"
                                            :options="ddMemberList"
                                            :defaultOptions="ddDefaultMemberList"
                                            :auto-load-root-options="convertToBool(searchUserId > 0 && searchUsername)"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            @select="selectMemberOptions"
                                            @deselect="deSelectMemberOptions"
                                            v-model="searchUserId" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["DUP"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_cminfo"
                                            :placeholder="getLanguage['GL']['NO']"
                                            v-model="searchCMinfo"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click=" newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>
                        {{this.getLanguage['MEM']['DIL']}}
                        <CButton v-if="checkModuleAccess2(constAccessType.delete) && deleted_items!=null && deleted_items.length>0" class="btnExcel" @click="blacklistMember()">
                            <i class="cil-ban" width="20" style="padding-left:2px"></i>
                            {{this.getLanguage["BTN"]["BLK"]}}
                        </CButton>
                        <CButton v-if="checkModuleAccess2(constAccessType.delete) && deleted_items!=null && deleted_items.length>0" class="btnExcel" @click="freezeMember()">
                            <i class="cil-snowflake" width="20" style="padding-left:2px"></i>
                            {{this.getLanguage["BTN"]["FK"]}}
                        </CButton>
                    </strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage['GL']['NO']}}</th>
                                <th style="text-align:center" v-if="(checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)) && isSENS == 1"> </th>
                                <th style="text-align:center" v-else-if="(checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)) && isSENS == 0"><input type="checkbox" v-model="checkAll" @change="selectAll()" style="width:15px;height:15px;" /></th>
                                <th>
                                    {{this.getLanguage["DB"]["BN"]}}
                                    <i @click="setSortTable('GPC')" :class="setSortLogo('GPC')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['MEM']['U']}}
                                    <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                </th>
                                <th>{{this.getLanguage['MEM']['CIP']}} </th>
                                <th>
                                    {{this.getLanguage['MEM']['LLTS']}}
                                    <i @click="setSortTable('LLTS')" :class="setSortLogo('LLTS')" class="sortlogo"></i>
                                </th>
                                <th>{{this.getLanguage['MEM']['DUP5']}}</th>
                                <th><span style="color: darkorange; font-weight: bold; ">{{getLanguage['MEM']['TSID']}}</span> / <span style="color: red; font-weight: 900;">{{getLanguage['MEM']['SU']}}</span></th>
                                <th>{{this.getLanguage['MEM']['PN']}}</th>
                                <th>{{this.getLanguage['MEM']['BA']}} </th>
                                <th class="tableCtnRight">
                                    {{this.getLanguage['MEM']['TD']}}
                                    <i @click="setSortTable('TD')" :class="setSortLogo('TD')" class="sortlogo"></i>
                                </th>
                                <th class="tableCtnRight">
                                    {{this.getLanguage['MEM']['CBL']}}
                                    <i @click="setSortTable('CBL')" :class="setSortLogo('CBL')" class="sortlogo"></i>
                                </th>
                                <th>{{this.getLanguage['MEM']['RMK']}}</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage['GL']['NO']}}</th>
                                <th style="text-align:center" v-if="(checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)) && isSENS == 1"> </th>
                                <th style="text-align:center" v-else-if="(checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)) && isSENS == 0"><input type="checkbox" v-model="checkAll" @change="selectAll()" style="width:15px;height:15px;" /></th>
                                <th>
                                    {{this.getLanguage["DB"]["BN"]}}
                                    <i @click="setSortTable('GPC')" :class="setSortLogo('GPC')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{this.getLanguage['MEM']['U']}}
                                    <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                </th>
                                <th>{{this.getLanguage['MEM']['CIP']}} </th>
                                <th>
                                    {{this.getLanguage['MEM']['LLTS']}}
                                    <i @click="setSortTable('LLTS')" :class="setSortLogo('LLTS')" class="sortlogo"></i>
                                </th>
                                <th>{{this.getLanguage['MEM']['DUP5']}}</th>
                                <th><span style="color: darkorange; font-weight: bold; ">{{getLanguage['MEM']['TSID']}}</span> / <span style="color: red; font-weight: 900;">{{getLanguage['MEM']['SU']}}</span></th>
                                <th>{{this.getLanguage['MEM']['PN']}}</th>
                                <th>{{this.getLanguage['MEM']['BA']}} </th>
                                <th class="tableCtnRight">
                                    {{this.getLanguage['MEM']['TD']}}
                                    <i @click="setSortTable('TD')" :class="setSortLogo('TD')" class="sortlogo"></i>
                                </th>
                                <th class="tableCtnRight">
                                    {{this.getLanguage['MEM']['CBL']}}
                                    <i @click="setSortTable('CBL')" :class="setSortLogo('CBL')" class="sortlogo"></i>
                                </th>
                                <th>{{this.getLanguage['MEM']['RMK']}}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if="arr_MemberList && arr_MemberList.length == 0 && (searchUserId == null || searchUserId == '')">{{this.getLanguage['MEM']['PSAM']}}</td>
                        <td colspan="100%" v-else-if="arr_MemberList && arr_MemberList.length == 0 && (searchCMinfo == null || searchCMinfo.length == 0)">{{this.getLanguage['MEM']['PSDI']}}</td>
                        <td colspan="100%" v-else-if="arr_MemberList && arr_MemberList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_MemberList" :class="data.RS == 1? 'blacklist-row': data.RS == 3? 'freeze-row': ''">
                            <td>{{ CountItem(index+1) }}</td>
                            <td v-if="(checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)) && isSENS == 1 && data.AGI == curAGI">
                                <span id="actionBtnCol">
                                    <div v-if="checkModuleAccess2(constAccessType.delete)" class="custom-tooltip">
                                        <input type="checkbox" :id="data.I" :value="data" v-model="deleted_items" style="width:15px;height:15px;">
                                    </div>
                                </span>
                            </td>
                            <td v-else-if="(checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)) && isSENS == 1 && data.AGI != curAGI">
                                <span id="actionBtnCol">
                                    <div v-if="checkModuleAccess2(constAccessType.delete)" class="custom-tooltip">
                                    </div>
                                </span>
                            </td>
                            <td v-else-if="(checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)) && isSENS == 0">
                                <span id="actionBtnCol">
                                    <div v-if="checkModuleAccess2(constAccessType.delete)" class="custom-tooltip">
                                        <input type="checkbox" :id="data.I" :value="data" v-model="deleted_items" style="width:15px;height:15px;">
                                    </div>
                                </span>
                            </td>
                            <td>
                                <span class="grid-line">{{ data.GN }} ({{ data.GPC }})</span>
                                <span class="saggroupname" v-if="data.SAGPC != ''">{{ data.SAGGN }} ({{ data.SAGPC }})</span>
                            </td>
                            <td v-if="(isSENS == 1 && data.AGI == curAGI) || isSENS == 0" class='kema-eft' @click="CheckingMember(data.AGI,data.MI)">
                                <span class="grid-line">
                                    <div class="custom-tooltip">
                                        <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                        <span v-if="convertToBool(data.MT)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.MT}}</span>
                                    </div>
                                    <div class="float-right ml-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                            <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                        </svg>
                                    </div>
                                </span>
                            </td>
                            <td v-else-if="isSENS == 1 && data.AGI != curAGI" class='kema-eft'>
                                <span class="grid-line">
                                    <div class="custom-tooltip">
                                        <span :style="getbgtooltip(data)">{{data.U}}</span>
                                        <span v-if="convertToBool(data.MT)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.MT}}</span>
                                    </div>
                                    <div class="float-right ml-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                            <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                        </svg>
                                    </div>
                                </span>
                            </td>
                            <td>{{ data.CIP }}</td>
                            <td>
                                <span v-if="data.LLTS != '1900-01-01T00:00:00'">
                                    <span class="grid-line">{{ formatDateTime(data.LLTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</span>
                                    <span class="grid-line">{{ data.LLIP }}</span>
                                </span>
                                <span v-else>-</span>
                            </td>
                            <td>
                                <span v-if="data.MBIP != ''">{{ data.MBIP }}</span>
                                <span v-else>-</span>
                            </td>
                            <td>
                                <span style="text-align:center;display:block">
                                    <span v-if="data.TSI > 0 && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="getSystemId(data)" :class="{opened: opened.includes(data.MI)}" class="pointer">
                                        <span style="color:darkorange">({{ data.TSI }})</span> / <span style="color:red">({{ data.TM }})</span>
                                    </span>
                                    <span v-else-if="data.TSI > 0 && isSENS == 1 && data.AGI != curAGI" :class="{opened: opened.includes(data.MI)}" class="pointer">
                                        <span style="color:darkorange">({{ data.TSI }})</span> / <span style="color:red">({{ data.TM }})</span>
                                    </span>
                                    <span class="grid-line" v-else>-</span>
                                    <table class='p-4 mt-2' v-if="opened.includes(data.MI)" style="width: 100%; background: #ebedef">
                                        <thead>
                                            <tr>
                                                <th>{{ getLanguage['LOGRPT']['SI'] }}</th>
                                                <th>{{ getLanguage['LOGRPT']['DT'] }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-for="(row,index) in arry_systemId[data.MI]">
                                                <tr style="text-align: left;">
                                                    <td @click="row.MI>0?toggleFingPrintId(row,data.MI):{}" :class="{opened: opened.includes(row.UBI+'_'+row.SI)}" :style="[row.MI>0?{'cursor':'pointer'}:{}]">{{ row.SI }} <span style="color:red" v-if="row.MI>0">({{row.MI}})</span></td>
                                                    <td>{{ formatDateTime(row.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                </tr>
                                                <tr v-if="opened.includes(row.UBI+'_'+row.SI)" style="background: darkred">
                                                    <td colspan="2" style="padding:2px">
                                                        <table class='p-4' style="width: 100%; background: #ebedef;margin-top:1px">
                                                            <thead>
                                                                <tr>
                                                                    <th style="background: darkgoldenrod;padding:0.25rem">{{getLanguage['GL']['NO']}}</th>
                                                                    <th style="background: darkgoldenrod; padding: 0.25rem">{{ getLanguage['LOGRPT']['ACC'] }}</th>
                                                                    <th style="background: darkgoldenrod; padding: 0.25rem">{{ getLanguage['LOGRPT']['DT'] }}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(item,index) in arry_visitorMembers[row.UBI+'_'+row.SI]" style="text-align:left">
                                                                    <td style="text-align:center">{{ CountItem(index+1) }}</td>
                                                                    <td>
                                                                        <router-link :to="{ path:'/M/MCMI', query:{ agi: item.AGI, i: item.MI, u: item.UB, cf: 7}}" target="_blank">{{ item.UB }}</router-link>
                                                                    </td>
                                                                    <td style="text-align: right;">{{ formatDateTime(item.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </span>
                            </td>
                            <td>
                                <span v-if="data.PN != ''">{{ HideInfo(getUserInfo.IHMI_C, data.PN, 4) }}</span>
                                <span v-else>-</span>
                            </td>
                            <td>
                                <span v-if="data.BankList && data.BankList.length != 0">
                                    <span class="grid-line" v-for="bank in data.BankList">
                                        <div class="custom-tooltip">
                                            <!--<span v-else-if="bank.RS==1">[Block.]</span>
                                <span v-else-if="bank.RS==3">[Freeze.]</span>
                                <span v-else-if="bank.IB">[HIGHRISK.]</span>-->
                                            <span :class="bank.RS == 1? 'blacklist-row': bank.RS == 3? 'freeze-row' : bank.RS == 4 ? 'warninglist-row' : bank.IB? 'highrisk-row':''"><span v-if="bank.RS==0">[Del.]</span>{{ bank.BN }} {{ HideInfo(getUserInfo.IHMI, bank.BA, 4) }} ({{ HideInfo(getUserInfo.IHMI, bank.BAN, 4) }})</span>
                                            <span v-if="bank.IB && bank.RS==2" class="custom-tooltiptext" style="background:red">{{getLanguage['BANK']['SBA']}}</span>
                                        </div>
                                    </span>
                                </span>
                                <span v-else>-</span>
                            </td>
                            <td class="tableCtnRight">{{ formatNumber(data.TD, 2, data.CS) }}</td>
                            <td class="tableCtnRight">{{ formatNumber(data.TBL, 2, data.CS) }}</td>
                            <td>
                                <span v-if="data.R != ''">{{ data.R }}</span>
                                <span v-else>-</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import { loadingFullScreen, constAccessType, constRejectReasonBL, constRejectReasonF } from '@/modules/Constant.js';
    import { mapGetters } from 'vuex';
    import { requiredIf } from 'vuelidate/lib/validators'
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            Loading
        },
        data() {
            return {
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                bool_fingerPrintLoading: [],
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: false, // Table Ascending Descending
                // dropdown value
                ddMemberList: null,
                ddDefaultMemberList: null,
                dd_cminfo: [],
                // search fields
                searchUserId: null,
                searchUsername: null,
                searchCMinfo: null,
                agi: 0,
                opened: [],
                arry_visitorMembers: [],
                arry_systemId: [],
                arr_MemberList: [],
                deleted_items: [],
                checkAll: false,
                bool_isMemberBlacklistDetailV: false,
                bool_isMemberFreezeDetailV: false,
                bool_blacklistCV: false,
                bool_freezeCV: false,
                obj_blacklist: {},
                obj_freeze: {},
                constAccessType: constAccessType,
                dd_rejectreason: [],
                dd_rejectreasonF: [],
                obj_Reject: {
                    "reason": null,
                    "reason2": ""
                },
                obj_RejectF: {
                    "reason": null,
                    "reason2": ""
                },
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess']),
        },
        created() {
            this.$parent.showSubMenu = 'M';
            this.$parent.showActiveMenu = 'M.MCMI';

            this.getInfoList();

            if (this.$route.query.cf) {
                this.searchCMinfo = [];
                this.searchCMinfo.push(this.$route.query.cf);
            }

            if (this.$route.query.i && this.$route.query.u && this.$route.query.agi) {
                this.searchUserId = this.$route.query.i;
                this.searchUsername = this.$route.query.u;
                this.agi = this.$route.query.agi;
                this.ddDefaultMemberList = [
                    { id: this.searchUserId, label: this.searchUsername }
                ];
            }

            this.getSameInfoMemberList();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
        },
        methods: {
            getInfoList() {
                this.dd_cminfo = [
                    { id: "0", label: this.getLanguage['MEM']['DUP0'] }, { id: "1", label: this.getLanguage['MEM']['DUP1'] },
                    { id: "2", label: this.getLanguage['MEM']['DUP2'] }, { id: "3", label: this.getLanguage['MEM']['DUP3'] },
                    { id: "4", label: this.getLanguage['MEM']['DUP4'] }, { id: "5", label: this.getLanguage['MEM']['DUP5'] },
                    { id: "6", label: this.getLanguage['MEM']['DUP6'] }, { id: "7", label: this.getLanguage['MEM']['DUP7'] }
                ];
            },
            CheckingMember(agi, mi) {
                let routeData = this.$router.resolve({ path: '/M/ML/CheckingMember', query: { agi: agi, i: mi } });
                window.open(routeData.href, '_blank');
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.MTBC) {
                        bgColor = data.MTBC;
                    }

                    if (data.MTC) {
                        textColor = data.MTC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor
                };
            },
            setSortTable(SV) {
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getSameInfoMemberList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getSameInfoMemberList();
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                this.getSameInfoMemberList();
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            getSameInfoMemberList() {
                if (this.searchUserId != null && this.searchUserId != '' && this.searchCMinfo != null && this.searchCMinfo.length != 0) {
                    this.bool_fullLoading = true;
                    var that = this;
                    var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                    var hasDefaultPath = false;
                    this.checkAll = false;
                    this.deleted_items = [];
                    if (path) {
                        hasDefaultPath = true;
                    }

                    var temp_ = "";
                    for (var i = 0; i < this.searchCMinfo.length; i++) {
                        if (i != 0) {
                            temp_ += ",";
                        }
                        temp_ += this.searchCMinfo[i];
                    }

                    path += "&f.CF=" + temp_;
                    path += "&f.AGI=" + this.agi;
                    path += "&f.I=" + this.searchUserId;

                    if (!hasDefaultPath && path) {
                        path = path.substring(1);
                    }

                    this.getDataApi(`/api/m/sinfo?${path}`,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.ddDefaultMemberList = null;                                
                                that.int_TP = Math.max(d.D.TotalPages, 1);
                                that.int_Total = d.D.TotalItems;
                                that.arr_MemberList = d.D.Items;
                                that.resizeTableHead()
                            }
                        });
                }
                else {
                    this.arr_MemberList = [];
                }

            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/0`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            selectMemberOptions(node, instanceId) {
                this.agi = node.agi;
            },
            deSelectMemberOptions(node, instanceId) {
                this.agi = 0;
            },
            toggleFingPrintId(data, member_id) {
                var that = this;
                var path = this.getListingParamQuery(1, 50, this.str_tableSortBy, this.bool_isSort);

                path += "&f[MI]=" + member_id;
                path += "&f[FPJI]=" + data.SI;
                path += "&f[AGI]=" + data.AGI;

                const index = that.opened.indexOf(data.UBI + '_' + data.SI);

                if (index > -1) {
                    that.opened.splice(index, 1)

                } else {
                    this.getDataApi(`/api/m/gsiu/?${path}`,
                        function (d, s) {
                            if (s) {
                                that.arry_visitorMembers[data.UBI + '_' + data.SI] = d.D.Items;
                                that.opened.push(data.UBI + '_' + data.SI)
                            }
                        });
                }
            },
            getSystemId(data) {
                var that = this;
                var path = this.getListingParamQuery(1, 50, this.str_tableSortBy, this.bool_isSort);

                path += "&f[MI]=" + data.MI;

                const index = that.opened.indexOf(data.MI);

                if (index > -1) {
                    that.opened.splice(index, 1)

                } else {
                    this.getDataApi(`/api/m/gsi/?${path}`,
                        function (d, s) {
                            if (s) {
                                that.arry_systemId[data.MI] = d.D.Items;
                                that.opened.push(data.MI)
                            }
                        });
                }
                this.resizeTableHead()
            },
            renderActionType(int_status) {
                switch (int_status) {
                    case 2:
                        return 'Login';
                        break;
                    default:
                        return 'Register';
                        break;
                }
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('ML', 'M', type);
            },
            selectAll() {
                this.deleted_items = [];
                if (this.checkAll) {
                    this.arr_MemberList.forEach((value, key) => {
                        this.deleted_items.push(value);
                    });
                }
            },
            blacklistMember() {
                this.bool_blacklistCV = false;
                this.dd_rejectreason = constRejectReasonBL;
                this.obj_blacklist = {
                    RM: null,
                    _d: null
                };
                this.obj_Reject = {
                    "reason": null,
                    "reason2": ""
                },

                    this.bool_isMemberBlacklistDetailV = true;
            },
            saveBlacklist() {
                this.bool_blacklistCV = true;

                var rejectreason = this.obj_Reject.reason == 999 ? this.obj_Reject.reason2 : this.obj_Reject.reason;

                if (rejectreason != "" && rejectreason != null) {
                    this.bool_fullLoading = true;
                    var that = this;
                    var dt = [];
                    this.deleted_items.forEach((value, key) => {
                        dt.push({
                            I: value.MI,
                            UTS: value.UTS,
                            BR: rejectreason,
                            AGI: value.AGI,
                            ICI: 1,
                            CI: value.CI,
                            U: value.U
                        });
                    });
                    this.postDataApi(`/api/m/bm`, dt,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.bool_isMemberBlacklistDetailV = false;
                                that.getSameInfoMemberList();
                            }
                        });
                }
            },
            freezeMember() {
                this.bool_freezeCV = false;
                this.dd_rejectreasonF = constRejectReasonF;
                this.obj_freeze = {
                    RM: null,
                    _d: null
                };
                this.obj_RejectF = {
                    "reason": null,
                    "reason2": ""
                },

                    this.bool_isMemberFreezeDetailV = true;
            },
            saveFreeze() {
                this.bool_freezeCV = true;

                var rejectreason = this.obj_RejectF.reason == 999 ? this.obj_RejectF.reason2 : this.obj_RejectF.reason;

                if (rejectreason != "" && rejectreason != null) {
                    this.bool_fullLoading = true;
                    var that = this;
                    var dt = [];
                    this.deleted_items.forEach((value, key) => {
                        dt.push({
                            I: value.MI,
                            UTS: value.UTS,
                            FR: rejectreason,
                            AGI: value.AGI,
                            ICI: 1,
                            CI: value.CI,
                            U: value.U
                        });
                    });

                    this.postDataApi(`/api/m/fm`, dt,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.bool_isMemberFreezeDetailV = false;
                                that.getSameInfoMemberList();
                            }
                        });
                }
            },
            ValidationBlackListErrMsg(value) {
                if (this.bool_blacklistCV) {
                    var validateObj = this.$v.obj_Reject[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.getLanguage["ERR"]["1001"], this.getLanguage["MEM"]["RR"]);
                    }
                }
            },
            ValidationFreezeErrMsg(value) {
                if (this.bool_freezeCV) {
                    var validateObj = this.$v.obj_RejectF[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.getLanguage["ERR"]["1001"], this.getLanguage["MEM"]["FRR"]);
                    }
                }
            },
            close3() {
                this.bool_isMemberBlacklistDetailV = !this.bool_isMemberBlacklistDetailV;
                this.bool_blacklistCV = false;
            },
            close4() {
                this.bool_isMemberFreezeDetailV = !this.bool_isMemberFreezeDetailV;
                this.bool_FreezeCV = false;
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        if (!headerCells[index]) return;  // Add a safety check to avoid undefined errors

                        const headerWidth = headerCells[index].getBoundingClientRect().width;
                        const bodyWidth = cell.getBoundingClientRect().width;
                        const width = `${Math.max(bodyWidth, headerWidth)}px`;

                        headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
        },
        validations: {
            obj_Reject: {
                reason2: {
                    required: requiredIf(function (vm) {
                        return !vm.reason || vm.reason == 999;
                    }),
                }
            },
            obj_RejectF: {
                reason2: {
                    required: requiredIf(function (vm) {
                        return !vm.reason || vm.reason == 999;
                    }),
                }
            }
        },
        watch: {
            getLanguage() {
                this.getInfoList();
            }          
        }
    }

</script>

<style>
    #back-Button {
        padding: 0;
        cursor: pointer;
        min-width: 20px;
        min-height: 10px;
        display: flex;
    }

    #title {
        display: flex;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Member/MemberInfo.vue